import defaultState from '@/store/promotion/state'

export default {
  setLoyaltyInfo(state, value) {
    state.loyaltyInfo = value
  },
  setShowLoyalty(state, value) {
    state.showLoyalty = value
  },
  setLoyaltyRewards(state, value) {
    state.rewards = value
  },
  setMyActivitiesTab(state, value) {
    state.myActivitiesTab = value
  },
  reset(state) {
    Object.assign(state, defaultState)
  },
}
